/** Fallback nav if API unavailable — root paths (no /obsidian prefix) */
export const FALLBACK_NAV = {
  sections: [
    {
      section: 'Dashboard',
      collapsible: false,
      live: false,
      items: [{ key: 'dashboard', label: 'Dashboard', icon: 'bi bi-grid-1x2-fill', link: '/' }],
    },
    {
      section: 'Intraday',
      collapsible: true,
      live: true,
      items: [
        { key: 'live_oc', label: 'Option Chain', icon: 'bi bi-activity', link: '/live-oc' },
        { key: 'live_fut', label: 'Futures Market', icon: 'bi bi-graph-up', link: '#' },
        { key: 'live_cash', label: 'Cash Market', icon: 'bi bi-cash-coin', link: '#' },
        { key: 'live_chart', label: 'Intraday Chart', icon: 'bi bi-bar-chart-line', link: '/intraday' },
        { key: 'trade_plan', label: 'Date-wise Trade Plan', icon: 'bi bi-journal-text', link: '/trade-plan' },
      ],
    },
    {
      section: 'EOD Analysis',
      collapsible: true,
      live: false,
      items: [
        { key: 'eod_oc', label: 'Option Chain', icon: 'bi bi-diagram-3', link: '/eod-oc' },
        { key: 'eod_fut', label: 'Futures Market', icon: 'bi bi-graph-up-arrow', link: '/eod-fut' },
        { key: 'eod_cash', label: 'Cash Market', icon: 'bi bi-currency-rupee', link: '#' },
        { key: 'eod_chart', label: 'EOD Chart', icon: 'bi bi-bar-chart', link: '/eod-chart' },
        { key: 'part_oi', label: 'Participant Wise OI', icon: 'bi bi-people', link: '/participant' },
      ],
    },
    {
      section: 'Data Sync',
      collapsible: true,
      live: false,
      items: [
        { key: 'live_sync', label: 'Live Data Sync', icon: 'bi bi-cloud-download', link: '/live-sync' },
        { key: 'eod_sync', label: 'EOD Data Sync', icon: 'bi bi-cloud-arrow-down', link: '/eod-sync' },
        { key: 'eod_import', label: 'EOD Data Import', icon: 'bi bi-database-up', link: '/eod-import' },
      ],
    },
    {
      section: 'Settings',
      collapsible: false,
      live: false,
      items: [{ key: 'settings', label: 'Settings', icon: 'bi bi-gear', link: '#' }],
    },
  ],
};
